<template>
  <div>
    <div class="fixed-top bg-light topbar" v-if="!hideTop">
      <div class="container-fluid">
        <div class="row py-1 justify-content-between align-items-center">
          <div class="col-8 col-md-4">
            <div class="d-flex align-items-center" style="padding: 4px 0">
              <div class="mr-3" v-if="dados">
                <img :src="dados.business_logo || 'https://img.freepik.com/vetores-premium/icone-do-robo-design-de-sinal-de-bot-conceito-de-simbolo-de-chatbot-servico-de-suporte-por-voz-bot-bot-de-suporte-on-line-estoque-ilustracao-vetorial_100456-34.jpg'" class="img-perfil">
              </div>
              <h6 class="mb-0 w-100 text-ellipsis">{{dados.business_name}}</h6>
            </div>
          </div>
          <div class="col-4 py-2 text-right d-md-none">
            <a href="javascript:" class="text-dark" @click="menu = !menu">
              <img src="../assets/icons/square.svg" style="width: 36px" alt="Menu">
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="menu-lateral" :class="{'opened': menu}" @click="menu = false">
      <div class="menu-body" @click.stop="menu = true">
        <div class="d-flex align-items-center justify-content-center mb-2">
          <img src="../assets/icon.png" alt="LeCard" style="width: 42px;">
        </div>
        <router-link to="/chat" active-class="btn--active" class="btn btn-block">
          <img src="../assets/icons/whatsapp.svg" alt="">
          <span>Chat</span>
        </router-link>
        <router-link to="/agents" active-class="btn--active" class="btn btn-block" v-if="dados.type === 1">
          <img src="../assets/icons/add-user.svg">
          <span>Agentes</span>
        </router-link>
        <router-link to="/config" active-class="btn--active" class="btn btn-block" v-if="dados.type === 1">
          <img src="../assets/icons/settings.svg">
          <span>Configs</span>
        </router-link>
        <router-link to="/admin" active-class="btn--active" class="btn btn-block" v-if="dados.master">
          <img src="../assets/icons/report.svg">
          <span>Admin</span>
        </router-link>
        <div class="menu-bottom">
          <div class="btn-status" title="Status do Bot" @click="toggleAlert">
            <div class="font-weight-bold">Alerta<b class="d-md-none">s no WhatsApp</b></div>
            <img src="../assets/icons/switch-on.svg" v-if="alerts">
            <img src="../assets/icons/switch-off.svg" v-else>
            <div class="mt-0 font-weight-bold" :class="{'text-primary': alerts}">{{ !alerts ? 'Desativado' : 'Ativado' }}</div>
          </div>
          <button class="btn btn-block" @click="sair(true)">
            <img src="../assets/icons/logout.svg" alt="Sair">
            <span>Sair</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Modal from "@/components/Modal";
  export default {
    name: 'TopBar',
    components: {Modal},
    props: ['hideTop'],
    data() {
      return {
        load: true,
        menu: false,
        deferredPrompt: null,
        showNotification: false
      }
    },

    methods: {
      installPwa() {
        this.deferredPrompt.prompt();
        this.deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            this.deferredPrompt = null;
          }
        });
      },

      sair() {
        this.$swal({
          text: "Deseja realmente sair do sistema?",
          buttons: ["Cancelar", "Sim!"],
          dangerMode: true
        }).then((res => {
          if (res) {
            this.logout(true);
          }
        }));
      },

      toggleAlert() {
        this.$store.state.alerts = !this.$store.state.alerts;
        this.$http.post('agents/alerts', { alerts: this.alerts })
          .then(response => {}, res => {
            console.log(res);
          });
      }
    },

    computed: {
      dados() {
        return this.$store.state.dataUser;
      },

      alerts() {
        return this.$store.state.alerts;
      }
    },

    created() {
      this.$parent.$on('toggleMenu', () => {
        this.menu = true;
      });

      window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();
        this.deferredPrompt = e;
      });
    }
  }
</script>
<style scoped>
.img-perfil {
  max-width: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.btn-status {
  cursor: pointer;
  background-color: #FFFFFF;
  display: block;
  border-radius: 4px;
  padding: 8px 3px;
  text-align: center;
  font-size: 9px;
  text-decoration: none;
  margin-bottom: 10px;
}

.btn-status img {
  width: 28px;
}

@media (min-width: 768px) {
  .topbar {
    margin-left: 70px;
  }
}
</style>
